<template>
  <main class="page-content">
    <Landing/>
    <Mindset/>
    <Pictures/>
    <Booking/>
    <!--<Prices/>-->
    <Salon/>
    <Services/>
    <Partner/>
    <Instagram/>
    <Summary/>
  </main>
</template>

<script>
import Landing from '../components/Landing';
import Mindset from '../components/Mindset';
import Instagram from '../components/Instagram';
import Salon from '../components/Salon';
import Summary from '../components/Summary';
import Partner from '../components/Partner';
import Pictures from "@/pages/home/components/Pictures";
//import Prices from "@/pages/home/components/Prices.vue";
import Services from "@/pages/home/components/Services.vue";
import Booking from "@/pages/home/components/Booking.vue";

export default {
  name: 'Home',
  components: {
    Services,
    //Prices,
    Landing,
    Mindset,
    Pictures,
    Partner,
    Salon,
    Instagram,
    Summary,
    Booking
    /*Services*/
  },
  methods: {
    animationsOnScroll() {
      const options = {
        root: null,
        threshold: 0,
        rootMargin: '0px 0px -300px 0px'
      };

      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(entry => {
          if (!entry.isIntersecting) {
            return;
          } else {
            entry.target.classList.add('appear');
            observer.unobserve(entry.target);
          }
        });
      }, options);

      const faders = document.querySelectorAll('.fade-in');
      const sliders = document.querySelectorAll('.slide-in');

      faders.forEach(fader => {
        observer.observe(fader);
      });

      sliders.forEach(slider => {
        observer.observe(slider);
      });
    }
  },
  mounted() {
    this.animationsOnScroll();
  },
  metaInfo: {
    title: 'Friseur im Herzen Hamburgs',
    titleTemplate: 'Haarlem Friseure | %s',
    meta: [
      {
        charset: 'utf-8'
      },
      {
        name: 'viewport', content: 'width=device-width, initial-scale=1'
      },
      {
        name: 'description',
        content: 'Willkommen bei Haarlem Friseure. Wir erfüllen Ihre Bedürfnisse und Wünsche rund um Ihre Haare, Schönheit und Ihr Wohlbefinden.'
      },
      {
        property: 'og:site_name', content: 'Haarlem Friseure'
      },
      {
        property: 'og:type', content: 'website'
      },
      {
        name: 'robots', content: 'index,follow'
      }
    ]
  }
}
</script>
